import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ControlContainer, FormControl, FormGroup } from '@angular/forms';
import { PessoaJuridica } from '@tivic-team/manager-ts/dist/grl';
import { PessoaJuridicaService } from 'app/services/grl/pessoa-juridica.service';
import { PessoaSearch } from 'app/services/grl/pessoa.search';
import { PessoaService } from 'app/services/grl/pessoa.service';
import { ParentFormGroup } from 'app/tools/parent-formgroup';
import { EMPTY, Observable, from } from 'rxjs';
import { filter, map, mergeMap, tap } from 'rxjs/operators';

@Component({
  selector: 'autocomplete-vistoriado-filter',
  templateUrl: './autocomplete-vistoriado-filter.component.html',
  styleUrls: ['./autocomplete-vistoriado-filter.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class AutocompleteVistoriadoFilterComponent implements OnInit {

  formGroup: FormGroup;
  concessionarios: PessoaJuridica[];
  @ViewChild("cdConcessionario", { static: false}) cdConcessionario: ElementRef;
  private _cdPessoa: number;
  private tpConcessao: number;

  constructor(
    private _controlContainer: ControlContainer,
    private _pessoaJuridicaService: PessoaJuridicaService,
    private _pessoaService: PessoaService
  ) { }

  ngOnInit() {
    this.formGroup = this._controlContainer.control as FormGroup;
    this.formGroup.addControl('concessionario', new FormControl());
    this.formGroup.get('concessionario').valueChanges.pipe(
      filter(keyword => this._validarTexo(keyword)),
      mergeMap(keyword => this._buscar(keyword)),
      tap(concessionarios => this._finalizarBusca(concessionarios))
    ).subscribe();
  }

  ngAfterViewInit() {
    this.formGroup.get('cdPessoa').valueChanges.pipe(
      mergeMap(cdConcessionario => this._carregar(cdConcessionario)),
      map(cdConcessionario => this.pessoaSelecionada(cdConcessionario)),
    ).subscribe();
  }

  pessoaSelecionada(pessoaJuridica: PessoaJuridica) {
    if(!pessoaJuridica) return;

    this.cdConcessionario.nativeElement.value = pessoaJuridica.pessoa.nmPessoa;
    this._cdPessoa = pessoaJuridica.cdPessoa;
    this.formGroup.get('cdPessoa').setValue(pessoaJuridica.cdPessoa);
    this.formGroup.markAsDirty();
  }

  clear() {
    this.formGroup.reset();
  }

  private _carregar(cdPessoa): Observable<PessoaJuridica>{
    if(!cdPessoa || isNaN(cdPessoa) || this._cdPessoa === cdPessoa){
      return EMPTY;
    }

    return from(this._pessoaService.get(cdPessoa));
  }
  
  private _validarTexo(keyword: string){
    if(keyword && keyword.length === 0)
      this.formGroup.get('cdPessoa').setValue("");
    return keyword && keyword.length > 2;
  }
  
  private _buscar(keyword: string){
    return from(this._pessoaJuridicaService.getPermissionario(
      new PessoaSearch({ nmPessoa: keyword, tpConcessao: this.tpConcessao })
    ));
  }

  private _finalizarBusca(resultado: PessoaJuridica[]){
    this.concessionarios = resultado
  }
}
